import { logEvent } from '@firebase/analytics';
import { analytics } from '../../firebase';
import { useSelector } from 'react-redux';
import { permissionCookiesAnaliticasState } from 'redux/slices/permissionSlice';
import { useLanguage } from 'context/languageContext';

export default function useAnalytics() {
  const selectorPermissionAn = useSelector(permissionCookiesAnaliticasState);
  const language = useLanguage();

  function logEventAnalytics(code: string, params?: any) {
    if (analytics && selectorPermissionAn) {
        try {
            logEvent(analytics, code, params ? {...params, ...{lang: language}} : {lang: language});
        } catch (error) {
            
        }
    }
  }
  
  return {
    logEventAnalytics
  };
}
